import { FC } from "react"
import cx from "classnames"
import { BiSolidFileJpg } from "react-icons/bi"

type Props = {
  className?: string
} & React.HTMLAttributes<HTMLOrSVGElement>

const JpgIcon: FC<Props> = ({ className, ...rest }: Props) => {
  return (
    <BiSolidFileJpg
      className={cx("w-5 h-5 transition-opacity", className)}
      {...rest}
    />
  )
}

export default JpgIcon
